import React from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Works.css";

const Works = () => {
  const worksData = [
    {
      id: 1,
      img: "/works1.png",
      alt: "NASA Images",
      text: "NASA Image Explorer: A Space Imagery App",
      route: "/works/nasa-images",
      description:
        "A full-stack web application that allows users to search the official NASA API and save their favorite images. It features a secure Node.js backend with Passport.js for authentication and a responsive React frontend for a seamless user experience across all devices.",
    },
    {
      id: 2,
      img: "/works2.png",
      alt: "My Magical Bedtime",
      text: "My Magical Bedtime: AI-powered App",
      route: "/works/my-magical-bedtime",
      description:
        "A full-stack MERN application that generates personalized, AI-powered bedtime stories for children. It has a secure Node.js backend with JWT for authentication and a responsive React frontend that allows users to customize stories, save their favorites, and listen to audio narration.",
    },
    {
      id: 3,
      img: "/works3.png",
      alt: "VisioQuest",
      text: "VisioQuest: A Face Recognition App",
      route: "/works/visioquest",
      description:
        "A full-stack application that uses MediaPipe AI to perform real-time face detection in images entirely in the browser. It features a responsive React frontend with URL input, file upload, and drag-and-drop support, backed by a Node.js CORS proxy for handling cross-origin images.",
    },
  ];

  return (
    <div className="works-section">
      <div className="works-layout">
        <div className="works-left">
          <h1 className="works-section-h1">W O R K S ————— </h1>
        </div>

        <div className="works-right">
          {worksData.map(({ id, img, alt, text, route, description }) => (
            <a
              key={id}
              href={route}
              target="_blank"
              rel="noopener noreferrer"
              className="works-card-link"
            >
              <Card className="review-card works-card">
                <Card.Body className="works-card-body">
                  <img
                    src={img || "/works_img.png"}
                    alt={alt || `Work ${id}`}
                    className="works-card-img"
                  />

                  <div className="works-card-content">
                    <div className="works-card-top">
                      <p className="works-card-text">{text}</p>

                      <Button
                        size="sm"
                        className="works-check-btn"
                        onClick={(e) => e.stopPropagation()}
                      >
                        Check
                      </Button>
                    </div>

                    <div className="works-card-description">{description}</div>
                  </div>
                </Card.Body>
              </Card>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Works;
